import { render, staticRenderFns } from "./GroupSolutionsTable.vue?vue&type=template&id=28df41f9&"
import script from "./GroupSolutionsTable.vue?vue&type=script&lang=js&"
export * from "./GroupSolutionsTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupSolutionsTable.vue?vue&type=style&index=0&id=28df41f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports